import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import SiteMeta from "@/components/SiteMeta";

import Home from "@/pages/public/Home";
import Products from "@/pages/public/Products";
import ProductDetail from "@/pages/public/ProductDetail";
import Categories from "@/pages/public/Categories";
import Deals from "@/pages/public/Deals";
import StaticPage from "@/pages/public/StaticPage";
import Contact from "@/pages/public/Contact";
import Login from "@/pages/public/Login";
import Signup from "@/pages/public/Signup";
import ForgotPassword from "@/pages/public/ForgotPassword";

import PortalDashboard from "@/pages/portal/PortalDashboard";
import PortalOrders from "@/pages/portal/PortalOrders";
import OrderDetail from "@/pages/portal/OrderDetail";
import PortalRequests from "@/pages/portal/PortalRequests";
import PortalComplaints from "@/pages/portal/PortalComplaints";
import PortalProfile from "@/pages/portal/PortalProfile";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import Requests from "@/pages/admin/Requests";
import Orders from "@/pages/admin/Orders";
import Customers from "@/pages/admin/Customers";
import AdminProducts from "@/pages/admin/Products";

import { Categories as AdminCategories, Plans as AdminPlans, Deals as AdminDeals, Branches as AdminBranches, Brands as AdminBrands } from "@/pages/admin/SimpleCruds";
import Payments from "@/pages/admin/Payments";
import Recovery from "@/pages/admin/Recovery";
import AdminComplaints from "@/pages/admin/Complaints";
import Reports from "@/pages/admin/Reports";
import Users from "@/pages/admin/Users";
import Roles from "@/pages/admin/Roles";
import Audit from "@/pages/admin/Audit";
import CMS from "@/pages/admin/CMS";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <SiteMeta />
          <Toaster position="top-right" richColors />
          <Routes>
            {/* Public */}
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/deals" element={<Deals />} />
            <Route path="/page/:key" element={<StaticPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/complaints" element={<ProtectedRoute customerOnly><PortalComplaints /></ProtectedRoute>} />

            {/* Customer Portal */}
            <Route path="/portal" element={<ProtectedRoute customerOnly><PortalDashboard /></ProtectedRoute>} />
            <Route path="/portal/orders" element={<ProtectedRoute customerOnly><PortalOrders /></ProtectedRoute>} />
            <Route path="/portal/orders/:id" element={<ProtectedRoute customerOnly><OrderDetail /></ProtectedRoute>} />
            <Route path="/portal/requests" element={<ProtectedRoute customerOnly><PortalRequests /></ProtectedRoute>} />
            <Route path="/portal/complaints" element={<ProtectedRoute customerOnly><PortalComplaints /></ProtectedRoute>} />
            <Route path="/portal/profile" element={<ProtectedRoute customerOnly><PortalProfile /></ProtectedRoute>} />

            {/* Admin */}
            <Route path="/admin" element={<ProtectedRoute staffOnly><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/requests" element={<ProtectedRoute staffOnly><Requests /></ProtectedRoute>} />
            <Route path="/admin/orders" element={<ProtectedRoute staffOnly><Orders /></ProtectedRoute>} />
            <Route path="/admin/customers" element={<ProtectedRoute staffOnly><Customers /></ProtectedRoute>} />
            <Route path="/admin/products" element={<ProtectedRoute staffOnly><AdminProducts /></ProtectedRoute>} />
            <Route path="/admin/categories" element={<ProtectedRoute staffOnly><AdminCategories /></ProtectedRoute>} />
            <Route path="/admin/brands" element={<ProtectedRoute staffOnly><AdminBrands /></ProtectedRoute>} />
            <Route path="/admin/plans" element={<ProtectedRoute staffOnly><AdminPlans /></ProtectedRoute>} />
            <Route path="/admin/payments" element={<ProtectedRoute staffOnly><Payments /></ProtectedRoute>} />
            <Route path="/admin/recovery" element={<ProtectedRoute staffOnly><Recovery /></ProtectedRoute>} />
            <Route path="/admin/deals" element={<ProtectedRoute staffOnly><AdminDeals /></ProtectedRoute>} />
            <Route path="/admin/complaints" element={<ProtectedRoute staffOnly><AdminComplaints /></ProtectedRoute>} />
            <Route path="/admin/branches" element={<ProtectedRoute staffOnly><AdminBranches /></ProtectedRoute>} />
            <Route path="/admin/reports" element={<ProtectedRoute staffOnly><Reports /></ProtectedRoute>} />
            <Route path="/admin/cms" element={<ProtectedRoute staffOnly><CMS /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute staffOnly><Users /></ProtectedRoute>} />
            <Route path="/admin/roles" element={<ProtectedRoute staffOnly><Roles /></ProtectedRoute>} />
            <Route path="/admin/audit" element={<ProtectedRoute staffOnly><Audit /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute staffOnly><Settings /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
